<template src="./Appointment.html" />

<script>
import { showAlert } from "@/utils/helpers";

export default {
  props: {
    patientId: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.vm.patientId = this.patientId;
    this.$store.dispatch("appointments/getDoctors");
    this.$store.dispatch("lookups/getLookups");

  },
  computed: {
    doctors() {
      return this.$store.state.appointments.doctors;
    },
    appointmentTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.AppointmentTypes
      ).filter(x => x.value == 8001);
    },

    procedures() {
      return [{
        value: "خدمات قسم التجميل الجراحي",
        label: "خدمات قسم التجميل الجراحي"
      },
      {
        value: "خدمات قسم التجميل اللاجراحي",
        label: "خدمات قسم التجميل اللاجراحي"
      },
      {
        value: "خدمات قسم التغذية",
        label: "خدمات قسم التغذية"
      },
      {
        value: "خدمات قسم العناية بالبشرة",
        label: "خدمات قسم العناية بالبشرة"
      },
      {
        value: "خدمات قسم الليزر",
        label: "خدمات قسم الليزر"
      }, {
        value: "كشوفات",
        label: "كشوفات "
      },]
    },
    itemPriceList() {
      return this.$store.state.lookups.itemPriceList || [];
    },

  },
  data() {
    return {
      procedureId: null,
      selectedPriceItem: null,

      vm: {
        appointmentDate: null,
        doctorId: null,
        patientId: null,
        appointmentTypeId: null,
        appointmentType: null,
        remarks: null,
      },
      allowedDays: [],

    };
  },
  methods: {
    getServices() {
      this.vm.appointmentType = null;
      this.$store.dispatch("lookups/GetItemByProcedure", this.procedureId);
    },
    onPriceItemSelected() {
      const item = this.selectedPriceItem;
      if (item && item) {
        this.vm.appointmentType = item;
        this.showBtn = true;
      } else {
        this.vm.appointmentType = null;
      }
    },

    allowedDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // تصفير الوقت
      const selectedDate = new Date(date);
      const day = selectedDate.getDay(); // اليوم من الأسبوع
      const isDayAllowed = this.allowedDays.includes(day); // تحقق من الأيام المسموحة
      const isDateAllowed = selectedDate >= today; // تحقق من التاريخ
      return isDayAllowed && isDateAllowed; // تحقق من الشرطين
    },

    getDoctorAppointments() {
      this.allowedDays = [];
      this.doctors.forEach(element => {
        if (element.value == this.vm.doctorId) {
          element.appointmentSettings.forEach(e => {
            this.allowedDays.push(e.id)
          });
        }
      });
    },

    confirm() {
      if (this.vm.appointmentType != null) {
        let service = this.itemPriceList.find(x => x.itemName == this.vm.appointmentType);
        this.vm.serviceCode = service.itemCode;
      }

      this.$refs.form.validate().then(valid => {
        if (valid) {
          this.$store
            .dispatch("bookPatients/addAppointment", this.vm)
            .then((res) => {
                 this.$emit("next", res.data);
            })
            .catch(() => { });
        } else {
          showAlert(`الرجاء التحقق من تعبئة جميع الحقول  `);

        }
      });
    },
    checkAppointment() {
      this.showBtn = false;
      if (this.vm.appointmentTypeId == 8002) {
        this.$store
          .dispatch("appointments/checkAppointment", {
            patientId: this.vm.patientId,
            doctorId: this.vm.doctorId,
          }
          )
          .then((res) => {
            if (res != undefined) {
              this.showBtn = true;
            }
          })
          .catch(() => { });
      }
      else if (this.vm.appointmentTypeId == 8003) {
        this.$store
          .dispatch("appointments/checkFollowup", {
            patientId: this.vm.patientId,
            doctorId: this.vm.doctorId,
          }
          )
          .then((res) => {
            if (res != undefined) {
              this.showBtn = true;
            }
          })
          .catch(() => { });
      }
      else {
        this.showBtn = true;
      }
    },
    checkitemPriceList() {
      this.vm.itemPriceList = this.itemPriceList
    },

    back() {
      this.$emit("back");
    },
  },
};
</script>